var map = {
	"./Tabulator.png": 259,
	"./ai-chatbot.png": 1093,
	"./airtable.svg": 293,
	"./appwrite.svg": 201,
	"./aurora.svg": 874,
	"./boldsign.svg": 260,
	"./box.svg": 261,
	"./chatgpt-logo.png": 362,
	"./claudeai.svg": 1094,
	"./database.svg": 1095,
	"./deepseekai.svg": 1096,
	"./directus.svg": 202,
	"./drapcode.png": 999,
	"./firebase-cloud-firestore.svg": 1097,
	"./firebase-cloud-function.svg": 1098,
	"./firebase-database.svg": 1099,
	"./firebase-realtime-database.svg": 1100,
	"./firebase.svg": 1101,
	"./google-calendar.svg": 262,
	"./google-meet.svg": 263,
	"./google-sheets-white.svg": 1102,
	"./google-sheets.svg": 1103,
	"./integromat.svg": 1104,
	"./m-pesa.svg": 264,
	"./mariadb.svg": 875,
	"./ms-sql-server.svg": 876,
	"./mysql.svg": 209,
	"./notion.svg": 1105,
	"./oAuth2-logo.svg": 1106,
	"./openai.svg": 1107,
	"./oracledb.svg": 877,
	"./pinecone.png": 1108,
	"./postgresql.svg": 878,
	"./qr.svg": 265,
	"./rocket.svg": 879,
	"./salesforce.svg": 294,
	"./signzy.svg": 266,
	"./spin-mobile.svg": 267,
	"./sqlite.svg": 880,
	"./supabase.svg": 203,
	"./xano.svg": 204,
	"./xata.svg": 295,
	"./zapier.svg": 222,
	"./zoom.svg": 268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 130;